import { Message } from '@dinosband/bv-messenger-schema'
import { queryMessageDetail } from '@dinosband/bv-messenger-client'
import type { MessageCacheIndexedDB } from '@dinosband/bv-cache'
import { failedMessageCache, messageCache } from '@dinosband/bv-cache'

import { MessengerContext } from '..'
import { ChatRoomContext } from './chat-room-context'

type MessageCacheSingle = {
  load: () => Promise<void>
  contents: () => Message[]
  remove: (mesg: Message) => void
  put: (mesg: Message) => void
  flush: () => Promise<void>
  reset: () => Promise<void>
}

export interface FailedMessage {
  seq: number
  props: unknown
}


export class HomelessChatRoomContexts {

  context: MessengerContext

  homelessChatRoomContexts: ChatRoomContext[] = []
  failedMessagesCursor = { cursor: 1 }

  private messageCache: MessageCacheIndexedDB | null = null
  private failedMessageCache: MessageCacheSingle | null = null

  constructor (context: MessengerContext) {
    this.context = context
    this.messageCache = messageCache
    this.failedMessageCache = failedMessageCache
  }

  get contexts () {
    return this.homelessChatRoomContexts
  }

  async init () {
    // this.messageCache = (await import('@dinosband/bv-cache')).messageCache
    // this.failedMessageCache = (await import('@dinosband/bv-cache')).failedMessageCache
    await this.initFailMessageCache()
  }

  async cleanup () {
    this.homelessChatRoomContexts = []
    await this.failedMessageCache?.reset()
    this.failedMessagesCursor.cursor++
  }

  async initFailMessageCache () {
    await this.failedMessageCache?.load()
    const invalids = this.homelessFailedMessages.filter((i) => !i.props.targetProfileId)
    invalids.forEach((i) => { this.removeFailedMessage(i) })
    this.updateHomelessChatRoomContexts()
  }

  get homelessFailedMessages () {
    const messages = this.failedMessageCache?.contents() || []
    return messages.filter((i) => !i.chatRoomId)
  }

  putFailedMessage (draft: Message) {
    this.failedMessageCache?.put(draft)
    this.failedMessageCache?.flush()
    this.updateHomelessChatRoomContexts()
  }

  getFailedMessages (chatRoomId?: number) {
    const contents = this.failedMessageCache?.contents() || []
    return contents.filter((i) => i.chatRoomId == chatRoomId)
  }

  removeFailedMessage (draft: Message) {
    this.failedMessageCache?.remove(draft)
    this.failedMessageCache?.flush()
    this.updateHomelessChatRoomContexts()
  }

  async updateHomelessChatRoomContexts () {
    const homelesses = this.homelessFailedMessages
    for (const i of homelesses) {
      const rootMessageId = i.props.rootMessageId
      let rootMessage: Message | undefined
      if (rootMessageId) {
        if (this.homelessChatRoomContexts.find((j) => j.rootMessageId === rootMessageId)) {
        // already
          return
        }
        if (i.props.rootMessageChatRoomId) {
          rootMessage = await this.messageCache?.getById(i.props.rootMessageChatRoomId, rootMessageId) || undefined
        }
        if (!rootMessage) {
          rootMessage = await queryMessageDetail(await this.context.messengerClient.getClient(), i.props.rootMessageChatRoomId ?? 0, rootMessageId)
        }
      }
      // const targetId = i.props.targetProfileId
      // const others: Profile[] = []
      // if (targetId) {
      //   const target = await mainStore.readProfile(targetId)
      //   others.push(target)
      // }
      const context = ChatRoomContext.temporary(i.props.chatRoomType, i.profileId, rootMessage as unknown as Message)
      context.failedMessage = i
      this.homelessChatRoomContexts.push(context)
    }
    this.failedMessagesCursor.cursor++
  }


}